export async function openSharePopup(
    resolveUrl: () => Promise<string>,
    buildUrl: (url: string) => string,
): Promise<void> {
    const popup = window.open('', '_blank');
    if (popup) {
        popup.opener = null;
    }

    try {
        const url = buildUrl(await resolveUrl());
        if (popup) {
            popup.location.href = url;
        } else {
            window.open(url, '_blank', 'noopener,noreferrer');
        }
    } catch (error) {
        popup?.close();
        throw error;
    }
}
